import React, { useCallback, useEffect, useRef, useState } from 'react'
import intl from 'react-intl-universal'
import { Tabs } from 'antd-mobile'

import Article from '../../../components/Article'

import CartIcon from '../../../components/Icon/CartIcon'
import AutoImage from '../../../components/AutoImage'
import RelateTagList from '../../../components/RelateTagList'
import { scrollToElement } from '../../../utils/elementScroll'
import { isInSellingTime } from '../../../utils/bookRule'
import math from '../../../utils/math'
import NumStepper from '../../../components/NumStepper'
import defImg from '../../../assets/images/def_img_food.png'
// import { debounce } from 'lodash'
import debounce from 'lodash/debounce';



import './index.less'
import PriceText from '../PriceText'
import ProductOriPrice from '../../ProductOriPrice'
import PackageDiscountBadge from '../../PackageDiscountBadge'
import { replaceCDNDomain } from '../../../utils'

// 商品数量组件
const ProductNum = ({ items, productId, cls = '', needBrackets = false }) => {
    if (!items) return null

    const item = items?.filter(item => item.productId === productId)
    const quantity = item?.reduce((sum, item) => math.add(sum, item.quantity), 0)
    return quantity ? <div className={`product-num ${cls}`}>{needBrackets ? `(${quantity})` : quantity}</div> : null
}

const ProductDetail = ({
    currentItem,
    addToCart,
    cartList = [],
    readonly = false,
    removeFromCart,
    showAttr,
    showAttrModal,
    merchantInfo,
    children
}) => {
    const [activeKey, setActiveKey] = useState('1')
    const lastScrollYRef = useRef(window.scrollY)
    const [tabItems, setTabItems] = useState([])

    let { bookingInstructions, notes } = currentItem || {}
    const { storeInfo } = merchantInfo || {}
    if (!bookingInstructions) {
        bookingInstructions = storeInfo?.bookingInstructions
    }
    if (!notes) {
        notes = storeInfo?.notes
    }

    const renderTabItems = useCallback(() => {
        const tabItems = [
            {
                key: '1',
                title: intl.get('t_info').d('Info')
            }
        ]
        if (bookingInstructions) {
            tabItems.push({
                key: '2',
                title: intl.get('book_tips').d('预定须知')
            })
        }
        if (notes) {
            tabItems.push({
                key: '3',
                title: intl.get('notice_item').d('注意事项')
            })
        }
        setTabItems(tabItems)
    }, [bookingInstructions, notes]);

    useEffect(() => {
        renderTabItems()
    }, [renderTabItems])

    const inSellingTime = isInSellingTime(currentItem.sellingTimeRange, currentItem.sellingTimeRangeJson).state
    const isActive = !(currentItem.stock === 0 || currentItem.status === 2) && inSellingTime

    // console.log(inSellingTime, '====////inSellingTime====')

    const renderProductActions = useCallback((item) => {
        if (item.stock === 0) return null
        const subAttrLen = item.attrs.flatMap(attr => attr.subAttrList || []).length
        const attrFlag = (item.attrs.length > 0 || subAttrLen > 0) || item.specs?.length > 0

        return <div className='jm-flex'>
            <span className='jm-price jm-flex-item fs-18'>
                <PriceText product={item} />
                <ProductOriPrice item={item} />
            </span>
            {
                !readonly && isActive && (
                    <div>
                        {
                            attrFlag
                                ?
                                <div
                                    className='btn-add-cart jm-flex'
                                    style={{ fontWeight: 'bold' }}
                                    onClick={e => showAttrModal(item)}>
                                    <CartIcon color="#fff" width={20} height={20} />&nbsp;
                                    {intl.get('addToCart').d('Add to Basket')}
                                    <ProductNum items={cartList} productId={currentItem.productId} needBrackets={true} />
                                </div>
                                :
                                <NumStepper
                                    max={item.orderMaxNum || (item.stock === -1 ? 99 : item.stock)}
                                    items={cartList}
                                    onAdd={item => {
                                        addToCart(item)
                                    }}
                                    onRemove={removeFromCart}
                                    curProduct={item}
                                />
                        }

                    </div>
                )
            }

        </div>
    }, [cartList, addToCart, removeFromCart])

    const { productImages } = merchantInfo || {}

    const img = productImages || defImg


    const calculatePageHeight = () => {
        const height = window.innerHeight
        console.log('resize', height, '=====////resize/////')
        document.querySelector('.js_product_dt_content').style.height = (height - 110) + 'px'
    }
    useEffect(() => {
        calculatePageHeight(); // 初始计算

        const handleResize = debounce(calculatePageHeight, 100);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);



    return (
        <div className='pd-popup-wrapper'>
            <div className='pd-popup-title'>{currentItem.productName}</div>
            <div className='pd-popup-content js_product_dt_content' style={{ height: '90vh', overflowY: 'auto' }}>
                <div className='pd-popup-img'>
                    <AutoImage
                        src={replaceCDNDomain(currentItem.images || img)}
                        alt={currentItem.productName}
                        className='w-100pc'
                        size='original'
                        onError={e => {
                            // console.log('img', img, '=====////img/////')
                            e.target.src = img
                        }}
                    />
                    <PackageDiscountBadge product={currentItem} />
                </div>
                {
                    currentItem.tagRelates && currentItem.tagRelates.length > 0 && (
                        <div style={{ padding: '5px 10px 0 10px' }}>
                            <RelateTagList list={currentItem.tagRelates} />
                        </div>
                    )
                }
                <div className='pd-popup-info p10 bg-white'>
                    {renderProductActions(currentItem)}
                    {
                        currentItem.bookingInstructions && (
                            <div className='pd-popup-desc hide'>{currentItem.bookingInstructions}</div>
                        )
                    }

                </div>

                {
                    (bookingInstructions || notes) ?
                        <div className='tabs-container m-t-sm'>
                            <Tabs
                                activeKey={activeKey}
                                onChange={key => {
                                    const target = document.getElementsByClassName(`product-tab-${key}`)[0]
                                    scrollToElement({
                                        target,
                                        offset: 148,
                                        gridHeight: 0,
                                        lastScrollYRef: lastScrollYRef,
                                        container: document.querySelector('.pd-popup-content')
                                    })

                                    setTimeout(() => {
                                        setActiveKey(key)
                                    }, 100)

                                }}
                            >
                                {tabItems.map(item => (
                                    <Tabs.Tab title={item.title} key={item.key} />
                                ))}
                            </Tabs>
                        </div>
                        :
                        <div style={{ height: 10, backgroundColor: '#f5f5f5' }}>&nbsp;</div>
                }
                <div className='pd-popup-main bg-white p10 product-tab-1'>
                    <div className='pd-popup-main-title fs-16 hide'><b>{intl.get('product_detail').d('产品详情')}</b></div>
                    <div className='pd-popup-main-content'>
                        <Article list={currentItem.description} />
                    </div>

                    {
                        bookingInstructions && (
                            <div className='m-b-sm product-tab-2' style={{ marginTop: 10 }}>
                                <div className='detail-title'>
                                    <span>{intl.get('book_tips').d('预定须知')}</span>
                                </div>
                                <div className='tb-content' style={{ padding: 0, marginTop: 5 }} >
                                    <div className='act-info'>
                                        <div style={{ whiteSpace: 'pre-wrap' }}>{bookingInstructions}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        notes && (
                            <div className='m-b-sm product-tab-3' style={{ marginTop: 10 }}>
                                <div className='detail-title'>
                                    <span>{intl.get('notice_item').d('注意事项')}</span>
                                </div>
                                <div className='tb-content' style={{ padding: 0, marginTop: 5 }} >
                                    <div className='act-info'>
                                        <div style={{ whiteSpace: 'pre-wrap' }}>{notes}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    <br />
                    <br />
                    <br />

                </div>
            </div>
            {children}
        </div>
    )
}

export default ProductDetail